// Module
var code = "<multi-session-workshop-host></multi-session-workshop-host>";
// Exports
module.exports = code;